import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PercentPipe } from '@angular/common';
@Component({
  selector: 'app-table-percent-cell',
  imports: [PercentPipe],
  templateUrl: './table-percent-cell.component.html',
  styleUrl: './table-percent-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    '[style.color]': 'color()',
  },
})
export class TablePercentCellComponent {
  value = input<number | string>();
  color = input<string>('var(--white)');
  disabledFormat = input<boolean>(false);
}
